import { Flex, Skeleton } from '@chakra-ui/react';

export const CompetencyLoading = () => (
  <Flex flex="1" p="12px" gap="12px" flexDirection="column">
    <Skeleton height="82px" width="100%" />
    <Skeleton height="57px" width="100%" />
    <Skeleton height="57px" width="100%" />
    <Skeleton height="57px" width="100%" />
    <Skeleton height="57px" width="100%" />
    <Skeleton height="57px" width="100%" />
    <Skeleton height="57px" width="100%" />
    <Skeleton height="40px" width="150px" />
  </Flex>
);

export const CompetencyInitiativeLoading = () => (
  <Flex flex="1" p="12px" gap="12px" flexDirection="column">
    <Skeleton height="57px" width="100%" />
    <Skeleton height="57px" width="100%" />
    <Skeleton height="57px" width="100%" />
    <Skeleton height="57px" width="100%" />
    <Skeleton height="57px" width="100%" />
    <Skeleton height="57px" width="100%" />
    <Skeleton height="40px" width="150px" />
  </Flex>
);
